import { Container, cssVar, NotificationCenter } from 'metrix-common3';
import { Helmet } from 'react-helmet-async';
import styled from 'styled-components';

import ChatbaseWidget from '../../components/ChatbaseWidget';
import Routes from '../../components/Routes';
import SupportPartner from '../../components/SupportPartner';

const Support = styled(SupportPartner)`
    position: fixed;
    cursor: pointer;
    bottom: 40px;
    right: 10px;
`;

const App = (props) => {
    window.zESettings = {
        webWidget: {
            color: { theme: `${cssVar.colorPrimary}` },
            offset: { mobile: { vertical: '85px' } },
        },
    };

    return (
        <Container>
            <Helmet>
                <title>{import.meta.env.VITE_Brand}</title>
                <link href='https://calendly.com/assets/external/widget.css' rel='stylesheet' />
                <script src='https://calendly.com/assets/external/widget.js' type='text/javascript' />
                {props.context?.configuration?.gtm && (
                    <script
                        async
                        src={`https://www.googletagmanager.com/gtm.js?id=${props.context.configuration.gtm}`}
                    />
                )}
                {props.context?.configuration?.metaPixelKey && (
                    <script>
                        {`
                            !function(f,b,e,v,n,t,s)
                            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                            n.queue=[];t=b.createElement(e);t.async=!0;
                            t.src=v;s=b.getElementsByTagName(e)[0];
                            s.parentNode.insertBefore(t,s)}(window, document,'script',
                            'https://connect.facebook.net/en_US/fbevents.js');
                            fbq('init', '${props.context.configuration.metaPixelKey}');
                            fbq('track', 'PageView');
                        `}
                    </script>
                )}
                {props.context?.configuration?.contentSquareKey && (
                    <script type='text/javascript'>
                        {`(function () {
                                window._uxa = window._uxa || [];
                                if (typeof CS_CONF === "undefined") {
                                    window._uxa.push([
                                        "setPath",
                                        window.location.pathname + window.location.hash.replace("#", "?__")
                                    ]);
                                    var mt = document.createElement("script");
                                    mt.type = "text/javascript";
                                    mt.async = true;
                                    mt.src = "//t.contentsquare.net/uxa/${props.context.configuration.contentSquareKey}.js";
                                    document.getElementsByTagName("head")[0].appendChild(mt);
                                } else {
                                    window._uxa.push([
                                        "trackPageview",
                                        window.location.pathname + window.location.hash.replace("#", "?__")
                                    ]);
                                }
                            })();`}
                    </script>
                )}
            </Helmet>
            <NotificationCenter />
            <ChatbaseWidget {...props} />
            <Routes {...props} />
            <Support {...props} />
        </Container>
    );
};

export default App;
